import axios from "axios";
import * as types from "./mutation_types";

export const getItems = ({ commit }) => {
  commit(types.DOMAINE_TOGGLE_LOADING);
  axios
    .get("/api/familles/")
    .then((response) => {
      commit(types.DOMAINE_TOGGLE_LOADING);
      commit(types.DOMAINE_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.DOMAINE_TOGGLE_LOADING);
      commit(types.DOMAINE_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.DOMAINE_RESET);
};
